<template>
  <div>
    <div class="box flex-row">
      <base-image :src="bonusPhaseIcon"></base-image>

      <div class="bonus_txt">
        <h3>{{ bonusPhaseTitle }}</h3>

        <p>{{ bonusPhaseDescription }}</p>
      </div>

      <base-countdown-timer
        :initial-timer-in-seconds="bonusPhaseTimer"
        timer-format="hh:mm:ss"
        class-name="bonus_timer"
        @time:expired="$emit('bonusPhase:expired', {type: bonusPhaseType})"
      ></base-countdown-timer>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import Vue from 'vue'
import BaseImage from '../common/image/BaseImage'
import BaseCountdownTimer from '../common/timer/BaseCountdownTimer'

const moment = require('moment')
Vue.use(require('vue-moment'), {moment})

export default {
  name: 'HomeBonusPhaseItem',
  components: {
    BaseImage,
    BaseCountdownTimer
  },
  emits:['bonusPhase:expired'],
  props: {
    bonusPhase: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      bonusPhaseConfigurationPerType: {
        POINTS: {
          getIcon: ({multiplier}) => `/static/images/x${multiplier}.svg`,
          getTitle: ({multiplier}) => `home_bonus_phase_game_points_title_x${multiplier}`,
          getDescription: ({multiplier}) => `home_bonus_phase_game_points_description_x${multiplier}`
        },
        BUNDLES: {
          getIcon: () => '/static/images/discount.svg',
          getTitle: () => 'home_bonus_phase_bundle_discount_title',
          getDescription: () => 'home_bonus_phase_bundle_discount_description'
        }
      }
    }
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations'
    ]),
    bonusPhaseType () {
      return this.bonusPhase.type
    },
    bonusPhaseIcon () {
      return (
        this.bonusPhaseConfigurationPerType[this.bonusPhaseType] &&
        this.bonusPhaseConfigurationPerType[this.bonusPhaseType].getIcon(this.bonusPhase)
      ) || ''
    },
    bonusPhaseTitle () {
      return (
        this.bonusPhaseConfigurationPerType[this.bonusPhaseType] &&
        this.getTranslations[this.bonusPhaseConfigurationPerType[this.bonusPhaseType].getTitle(this.bonusPhase)]
      ) || ''
    },
    bonusPhaseDescription () {
      return (
        this.bonusPhaseConfigurationPerType[this.bonusPhaseType] &&
        this.getTranslations[this.bonusPhaseConfigurationPerType[this.bonusPhaseType].getDescription(this.bonusPhase)]
      ) || ''
    },
    bonusPhaseTimer () {
      moment.locale('EN')
      const currentDate = moment()
      const endDate = moment(this.bonusPhase.end)

      return currentDate.isBefore(endDate)
        ? Math.ceil(moment.duration(endDate.diff(currentDate)).asSeconds())
        : 0
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/home/HomeBonusPhaseItem.vue